import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { deepMix } from '@antv/util';
import { column, columnOf, maybeColumnOf } from './utils/helper';
import { createGroups } from './utils/order';
/**
 * The DiffY transform apply offset for y0 channels.
 * Keep y unchanged, set y1 = max(otherY), if y1 > y, remove the data.
 */
export var DiffY = function DiffY() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$groupBy = options.groupBy,
    groupBy = _options$groupBy === void 0 ? 'x' : _options$groupBy,
    _options$series = options.series,
    series = _options$series === void 0 ? true : _options$series;
  return function (I, mark) {
    var encode = mark.encode;
    var _columnOf = columnOf(encode, 'y'),
      _columnOf2 = _slicedToArray(_columnOf, 1),
      Y = _columnOf2[0];
    var _columnOf3 = columnOf(encode, 'y1'),
      _columnOf4 = _slicedToArray(_columnOf3, 2),
      _ = _columnOf4[0],
      fy1 = _columnOf4[1];
    var _ref = series ? maybeColumnOf(encode, 'series', 'color') : columnOf(encode, 'color'),
      _ref2 = _slicedToArray(_ref, 1),
      S = _ref2[0]; // Create groups and apply specified order for each group.
    var groups = createGroups(groupBy, I, mark);
    // Only adjust Y1 channel.
    var newY1 = new Array(I.length);
    var _iterator = _createForOfIteratorHelper(groups),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var G = _step.value;
        var YG = G.map(function (i) {
          return +Y[i];
        });
        // Process each series.
        var _loop = function _loop(idx) {
          var i = G[idx];
          // Get the max Y of current group with current Y exclude.
          var max = Math.max.apply(Math, _toConsumableArray(YG.filter(function (_, _i) {
            return _i !== idx;
          })));
          // Diff Y value.
          newY1[i] = Y[i] > max ? max : Y[i];
        };
        for (var idx = 0; idx < G.length; idx++) {
          _loop(idx);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return [I, deepMix({}, mark, {
      encode: {
        y1: column(newY1, fy1)
      }
    })];
  };
};
DiffY.props = {};